import React from "react";
import {
  Switch,
  Route,
  Redirect,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import PageViewContainer from "../../../components/structure/PageViewContainer";
import Apps from "./Apps";

export default function AccountSettings(props) {
  let { path } = useRouteMatch();
  const location = useLocation();
  const pageRoute = location.pathname.split("/")[3];

  const getTitle = () => {
    switch (pageRoute) {
      case "apps":
        return "Apps";
      default:
        return "Apps";
    }
  };

  return (
    <PageViewContainer title={getTitle()} subTitle="Integration">
      <Switch>
        <Route
          path={`${path}/apps/`}
          render={() => <Apps {...props} />}
        />
        <Route path={`${path}`}>
          <Redirect to="/settings/integration/apps/" />
        </Route>
      </Switch>
    </PageViewContainer>
  );
}
